export const GridColumns = [
    {
        Title: 'Correlation Id',
        Accessor: 'correlationId',
        ColumnType: 'Text',
        Sortable: false,
        Id: 'correlationId',
        ClassName: "data-table header"
    },
   
    {
        Title: 'Message Type',
        Accessor: 'messageName',
        ColumnType: 'Text',
        Sortable: false,
        Id: 'messageName',
        ClassName: "data-table header"
    },
    {
        Title: 'Unique Id',
        Accessor: 'uniqueId',
        ColumnType: 'Text',
        Sortable: false,
        Id: 'uniqueId',
        ClassName: "data-table header"
    },
    {
        Title: 'Customer',
        Accessor: 'customerName',
        ColumnType: 'Text',
        Sortable: false,
        Id: 'customerName',
        ClassName: "data-table header"
    },
    {
        Title: 'Message Trigger',
        Accessor: 'triggerEvent',
        ColumnType: 'Text',
        Sortable: false,
        Id: 'triggerEvent',
        ClassName: "data-table header"
    },
    {
        Title: 'Sent Message',
        Accessor: 'messageBlobPath',
        ColumnType: 'DownloadableText',
        Sortable: false,
        Id: 'messageBlobPath',
        ClassName: "data-table header"
    },
    {
        Title: 'Status',
        Accessor: 'status',
        ColumnType: 'Text',
        Sortable: false,
        Id: 'status',
        ClassName: "data-table header"
    },
    {
        Title: 'Error Message',
        Accessor: 'errorMessage',
        ColumnType: 'Text',
        Sortable: false,
        Id: 'errorMessage',
        ClassName: "data-table header"
    },
    {
        Title: 'Created Date',
        Accessor: 'createdDate',
        ColumnType: 'Text',
        Sortable: true,
        Id: 'createdDate',
        ClassName: "data-table header"
    }
];